import React from 'react'
import { Create } from 'react-admin'
import Form from './form'

const ExportsCreate = props => {
  return (
    <Create {...props} >
      <Form />
    </Create>
  )
}

export default ExportsCreate
